export function isOneOfUsers(userUuid: string, users: { uuid: string }[]): boolean {
  return users.some((user) => user.uuid === userUuid)
}
